import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ValidationAccordionWrapper } from "./ValidationAccordianStyled";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box,Button } from "@mui/material";
import { Constant } from "./Constant";
export const ValidationAccordionComp = ({headers, rows,countries,messages}) => {
    function getUtilValue(countryId, productId, productVariationId, componentId) {
        const obj = rows.find((x) => x.countryId === countryId && x.productId === productId && x.productVariationId === productVariationId && x.componentId === componentId);
        if(obj)
        {
            return obj?.utilizationPercentNumber?"0.00":(obj.utilizationPercent);                              
  
        }
        else
        return "0.00";
        }
    return (
        <ValidationAccordionWrapper defaultExpanded={true}>
            <AccordionSummary
                className="accordian"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{Constant.VALIDATIONTITLE}</Typography>
                <span aria-required>{Constant.VALIDATIONSUBTITLE}</span>
            </AccordionSummary>
            <AccordionDetails >
            <Box className="content">
            <h6>{Constant.CONTENTHEADING}</h6>
            <div><span>* </span>{Constant.INS1}</div>
            {messages.map((msg) => (
            <div><span>* </span>{msg}</div>
            ))}
            </Box>
            <TableContainer component={Paper}>
                <Table  sx={{ minWidth: 400 }} aria-label="customized table" >
                    <TableHead>
                        <TableRow>
                            <TableCell>Country</TableCell>
                            <TableCell>Head Count</TableCell>
                            <TableCell>Product</TableCell>
                            <TableCell>Product Variation</TableCell>
                            {headers.map((header) => (
                                <TableCell key={header.componentId}>{header.componentName}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {countries.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell sx={{fontWeight:600}}>{row.countryName}</TableCell>
                                <TableCell>{row.headcount}</TableCell>
                                <TableCell>{row.productName}</TableCell>
                                <TableCell>{row.productVariationName}</TableCell>
                                {headers.map((cell) => (
                                    <TableCell key={cell.id} className={(getUtilValue(row.countryId, row.productId, row.productVariationId, cell.componentId)<0||getUtilValue(row.countryId, row.productId, row.productVariationId, cell.componentId)>100)?"error":""}>{
                                        getUtilValue(row.countryId, row.productId, row.productVariationId, cell.componentId)
                                    }</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
                <div>
                   
                </div>
            </AccordionDetails>
        </ValidationAccordionWrapper>
    );
};

export default ValidationAccordionComp;
